import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Импорт файлов локализации
import enTranslation from './locales/en.json';
import ruTranslation from './locales/ru.json';
import viTranslation from './locales/vi.json';
import trTranslation from './locales/tr.json';
import zhTranslation from './locales/zh.json';

// Инициализация i18next
i18n
  // Определение языка пользователя
  .use(LanguageDetector)
  // Интеграция с React
  .use(initReactI18next)
  // Инициализация i18next
  .init({
    // Ресурсы локализации
    resources: {
      en: enTranslation,
      ru: ruTranslation,
      vi: viTranslation,
      tr: trTranslation,
      zh: zhTranslation,
    },
    // Язык по умолчанию
    fallbackLng: 'en',
    // Отладка
    debug: process.env.NODE_ENV === 'development',
    // Опции обнаружения
    detection: {
      order: ['querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage', 'cookie'],
    },
    // Интерполяция
    interpolation: {
      escapeValue: false, // не экранировать HTML
    },
    // Разделитель для вложенных ключей
    keySeparator: '.',
    // Не использовать пространства имен
    ns: ['translation', 'common', 'theme', 'languages', 'home', 'fileUploader', 'modelUpload', 'upload'],
    defaultNS: 'translation',
  });

export default i18n; 